import React, { useEffect, useState } from "react";
import * as MyCells from '../../../../utils/Cells';

const VatAggregatePanel = (props) => {
    const [rows, setRows] = useState([]);
    // const [net, setNet] = useState(0);
    // const [size, setSize] = useState(0);

    useEffect(() => {
        // console.log(props);
        setRows(props.rows);
        // setSize(getSize())
        // setNet(getNet())
    }, [props]);

    function getSize() {
        // console.log(rows)
        return rows.length;
    }

    function getNet() {
        // console.log('itt')
        return rows.reduce((a, b) => a + (b.original.net || 0), 0)
    }

    function getVat() {
        // console.log('itt')
        return rows.reduce((a, b) => a + (b.original.vat || 0), 0)
    }

    function getAmount() {
        // console.log('itt')
        return rows.reduce((a, b) => a + (b.original.amount || 0), 0)
    }


    return (
        <div className="aggregate-data">
            <span>Sorok száma: {getSize()}</span>
            <span> Nettó: {<MyCells.NumberCell value={getNet()} />}</span>
            <span> Áfa: {<MyCells.NumberCell value={getVat()} />}</span>
            <span> Bruttó: {<MyCells.NumberCell value={getAmount()} />}</span>
        </div>
    );
};

export default VatAggregatePanel;